import React, { useCallback, useContext, useEffect } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { RootStoreContext } from "src/stores/RootStore";
import { UI } from "@wwimmo/ui";
import styles from "./ImportInvoices.module.css";
import { ImportInvoicesInput } from "./input/ImportInvoicesInput";
import { ImportInvoicesList } from "./list/ImportInvoicesList";

const ImportInvoicesBase = () => {
    const { t } = useTranslation();
    const { importInvoiceFilesStore } = useContext(RootStoreContext);

    useEffect(() => {
        importInvoiceFilesStore.init();

        return () => {
            importInvoiceFilesStore.dispose();
        };
        // Only run 1 time
        // eslint-disable-next-line
    }, []);

    const onDragEnter = useCallback(
        (event: React.DragEvent<HTMLDivElement>) => {
            event.preventDefault();
            event.stopPropagation();

            importInvoiceFilesStore.setIsDraggingOverDropZone(true);
        },
        [importInvoiceFilesStore]
    );

    const onDragLeave = useCallback(
        (event: React.DragEvent<HTMLDivElement>) => {
            event.preventDefault();
            event.stopPropagation();

            importInvoiceFilesStore.setIsDraggingOverDropZone(true);
        },
        [importInvoiceFilesStore]
    );

    return (
        <div>
            <div>
                {importInvoiceFilesStore.areFilesBeingImported ? (
                    <div className={`${styles.InvoicePreviewDropzoneContainer}`}>
                        <div>{t("screens.kredi_flow.document_import.documents_are_being_imported")}</div>
                        <UI.RotatingSpinner noLogo={true} size={25} />
                    </div>
                ) : undefined}
                {!importInvoiceFilesStore.areFilesBeingImported ? (
                    <>
                        <div
                            className={`${styles.InvoicePreviewDropzoneContainer} ${
                                importInvoiceFilesStore.isDraggingOverDropZone ? styles.DraggingOver : ""
                            }`}
                            onDragEnter={onDragEnter}
                            onDragLeave={onDragLeave}
                        >
                            <div>{t("screens.kredi_flow.document_import.title")}</div>
                            <ImportInvoicesInput handleClickManually={false} />
                            <UI.Icon color="var(--grey)" icon={UI.SVGIcon.Documents} />
                        </div>
                    </>
                ) : (
                    <></>
                )}
                <div className="mt-4">
                    <ImportInvoicesList />
                </div>
            </div>
        </div>
    );
};

export const ImportInvoices = Sentry.withProfiler(observer(ImportInvoicesBase));
